import { format, isValid, parseISO } from 'date-fns';

export const UNKNOWN_START_DATE = new Date(1900, 0, 1);

export const isUnknownStartDate = (date?: Date | null): boolean =>
  !!date && date.getFullYear() === 1900 && date.getMonth() === 0 && date.getDate() === 1;

export const isDummyStartDate = (startDate?: string | null): boolean => {
  if (!startDate) return false;
  return isUnknownStartDate(parseISO(startDate));
};

// check when the picker date matches the given date (by day)
export const isSameDayDate = (date?: Date | null, isoDate?: string | null): boolean => {
  if (!date || !isoDate) return false;
  const other = parseISO(isoDate);
  return (
    date.getFullYear() === other.getFullYear() &&
    date.getMonth() === other.getMonth() &&
    date.getDate() === other.getDate()
  );
};

// format date or return null if invalid
export const formatDateOrNull = (date?: Date | null): string | null =>
  date && isValid(date) ? format(date, 'yyyy-MM-dd') : null;

// show start date when unknown(dummy) dates are included or limit to min_found_date
export const resolveInitialStartDate = (startDate?: string | null, minFoundDate?: string | null): Date | null => {
  if (!isDummyStartDate(startDate) && minFoundDate) {
    return parseISO(minFoundDate);
  }
  return startDate ? parseISO(startDate) : null;
};
